module.exports = __webpack_public_path__ + "static/img/img_pic_big@2x.1786686659715.png";